import _ from 'lodash';
import defaultConfig from './defaultConfig';
import defalutConst from './defaultConst';
function compatibleConfig() {
    if (window.HS_CONST_VAL.pageSizeOption) {
        let pageSizeOption = window.HS_CONST_VAL.pageSizeOption;
        let pageSize = defaultConfig.pageSize;
        if (pageSizeOption) {
            if (pageSizeOption.length && !pageSizeOption.includes(pageSize)) {
                defalutConst.pageSize = pageSizeOption[0];
            } else if (pageSizeOption.length == 0) {
                window.HS_CONST_VAL.pageSizeOption = [20];
            }
        }

    }
    window.HS_CONST = _.assign({}, defaultConfig, window.HS_CONST);
    window.HS_CONST.permissionMap = _.assign({}, defaultConfig.permissionMap, window.HS_CONST.permissionMap);
    window.HS_CONST_VAL = _.assign({}, defalutConst, window.HS_CONST_VAL);
}

export {
    compatibleConfig
};